import React from 'react'

 const ProductSale = () => {
  return (
    <div>Product Sale</div>
  )
}
export default ProductSale;